import { render } from "./SettingsTabDrProfile.vue?vue&type=template&id=f9ca615c&scoped=true"
import script from "./SettingsTabDrProfile.vue?vue&type=script&lang=js"
export * from "./SettingsTabDrProfile.vue?vue&type=script&lang=js"

import "./SettingsTabDrProfile.vue?vue&type=style&index=0&id=f9ca615c&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ca615c"]])

export default __exports__